import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.409 1.054A.8.8 0 0 0 10.397.042L.547 3.326A.8.8 0 0 0 .442 4.8l3.385 1.693 3.065-3.065a.8.8 0 1 1 1.132 1.131L4.959 7.624 6.65 11.01a.8.8 0 0 0 1.475-.105z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })